export enum IceHockeyShotBlockedAttribute {
  BlockedByTeammate = 816,
  Snap = 970,
  Slap = 971,
  Wrist = 972,
  TipIn = 973,
  Backhand = 974,
  Shovel = 975,
  OneHanded = 976,
  WrapAround = 977,
}
